import React from "react";
import "./ParentGuardianAvatar.css";

/**
 * Default guardian avatar when no user_image is set.
 * role: father | mother | tutor | parent
 */
export default function ParentGuardianAvatar({
  relationship = "parent",
  size = 72,
  firstName = "",
  className = "",
}) {
  const role = String(relationship || "parent").toLowerCase();
  const kind =
    role.includes("mother") || role === "mom" || role === "mum"
      ? "mother"
      : role.includes("father") || role === "dad"
        ? "father"
        : role.includes("tutor") || role.includes("guardian")
          ? "tutor"
          : "parent";

  const initial = (firstName || "").trim().slice(0, 1).toUpperCase();

  return (
    <div
      className={`parent-guardian-avatar parent-guardian-avatar--${kind} ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg viewBox="0 0 64 64" width={size * 0.62} height={size * 0.62}>
        {kind === "mother" && (
          <>
            <circle cx="32" cy="22" r="12" fill="currentColor" opacity="0.95" />
            <path
              d="M14 54c2-12 10-18 18-18s16 6 18 18"
              fill="currentColor"
              opacity="0.9"
            />
            <path
              d="M20 14c4-8 20-8 24 0-6 2-18 2-24 0z"
              fill="currentColor"
              opacity="0.55"
            />
          </>
        )}
        {kind === "father" && (
          <>
            <circle cx="32" cy="22" r="12" fill="currentColor" opacity="0.95" />
            <path
              d="M14 54c2-12 10-18 18-18s16 6 18 18"
              fill="currentColor"
              opacity="0.9"
            />
            <rect
              x="20"
              y="10"
              width="24"
              height="6"
              rx="2"
              fill="currentColor"
              opacity="0.45"
            />
          </>
        )}
        {(kind === "tutor" || kind === "parent") && (
          <>
            <circle cx="32" cy="22" r="12" fill="currentColor" opacity="0.95" />
            <path
              d="M14 54c2-12 10-18 18-18s16 6 18 18"
              fill="currentColor"
              opacity="0.9"
            />
            <path
              d="M32 34l10 6v6H22v-6l10-6z"
              fill="currentColor"
              opacity="0.35"
            />
          </>
        )}
      </svg>
      {initial ? <span className="parent-guardian-avatar__initial">{initial}</span> : null}
    </div>
  );
}
